// The ONE sanctioned client-side money math: the matrix's Room-selector
// what-if view. Tap a level, watch the room price / GM pill / lot total
// move with zero latency — nothing persists (explicitly "not saved"), and
// the authoritative numbers (matrix cells, base-bid totals, the sheet) are
// always the server's. Inputs are the *_f floats the matrix wire carries
// for exactly this purpose; display-rounding only.

/** rate × SF, rounded to cents for display. */
export function extend(qtySf: number, rateSfF: number): number {
  return Math.round(qtySf * rateSfF * 100) / 100
}

/** GM% of a price against a per-SF cost blend; null when unpriceable. */
export function gmPct(price: number, cogsRateF: number | null, qtySf: number): number | null {
  if (cogsRateF == null || price <= 0 || qtySf <= 0) return null
  const cost = qtySf * cogsRateF
  return ((price - cost) / price) * 100
}

/** Sum of line prices, in cents-safe display rounding. */
export function lotTotal(lines: number[]): number {
  return Math.round(lines.reduce((sum, n) => sum + n, 0) * 100) / 100
}

/** Local display formatting for what-if numbers (the wire's money strings
 *  don't exist for values the client just derived). */
export function fmtWhatIf(n: number | null): string {
  if (n == null) return "—"
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n)
}
